<template>
    <div class="get-ssyg-list">
        <MyTitle theTitle="所属原告"/>
        <van-checkbox-group class="fd-com-scroll" v-model="result">
            <van-cell-group>
                <van-cell
                        v-for="(item, index) in sqrList"
                        clickable
                        :key="item.cId"
                        :title="item.cSqrxm"
                        @click="toggle(item, index)"
                >
                    <van-checkbox
                            :name="item"
                            ref="checkboxes"
                            slot="right-icon"
                    ></van-checkbox>
                </van-cell>
            </van-cell-group>
        </van-checkbox-group>
        <div class="fd-com-btn-container">
            <van-button
                type="info"
                round
                @click="goToAddYGDLR">
                确认
            </van-button>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../../components/common/myTitle'

    export default {
        data() {
            return {
                result: [],
                sqrInfo: [],
                sqrList: [],
                checkedYG:[],
            };
        },
        components: {
            MyTitle
        },
        activated() {
            this.initData()
        },
        methods: {
            toggle(item, index) {
                this.$refs.checkboxes[index].toggle();
                var sqr = {
                    sqrId: item.cId,
                    sqrXm: item.cSqrxm,
                    sqrLx: item.cSqrlx
                };
                let isPush = true;
                if (this.sqrInfo) {
                    this.sqrInfo.some((items, i) => {
                        if (items.sqrId == item.cId) {
                            this.sqrInfo.splice(i, 1);
                            isPush = false;
                        }
                    });
                }
                if (isPush) {
                    this.sqrInfo.push(sqr);
                    this.sqrInfo.forEach((item,index)=>{
                        this.checkedYG.push(item.sqrXm)
                    })
                    sessionStorage.setItem("checkBqYg",JSON.stringify(this.checkedYG))
                }
            },
            initData() {
                return new Promise((resolve) => {
                    const bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                    this.$axios.get('ssbq/api/sqrs?bqid=' + bqid)
                        .then(res => {
                            res.data.forEach((item) => {
                                if (item.cSqrlx != "1") {
                                    item.cSqrxm = item.cQymc
                                }
                                item.cSqrxm = item.cSqrxm.length > 15 ? item.cSqrxm.substring(0, 15) + "..." : item.cSqrxm;
                            })
                            this.sqrList = res.data;
                            resolve(res.data);
                        }).catch(function (error) {
                        console.log(error)
                    });
                });
            },
            goToAddYGDLR: function () {
                sessionStorage.setItem("bqSqrInfo", JSON.stringify(this.sqrInfo));
                this.$router.push({
                    path: "/addBqYgdlr"
                });
            },
            checkedSqr(list) {
                let checkedSqrs = JSON.parse(sessionStorage.getItem("checkedSqr"));
                list.forEach((item, index) => {
                   checkedSqrs && checkedSqrs.forEach((ite) => {
                        if (ite.sqrId == item.cId) {
                            this.$refs.checkboxes[index].toggle();
                            var sqr = {
                                sqrId: item.cId,
                                sqrXm: item.cSqrxm,
                                sqrLx: item.cSqrlx
                            };
                            this.sqrInfo.push(sqr);
                        }
                    })
                })
            }
        },
        created() {
            this.initData().then((list) => {
                this.checkedSqr(list);
            });
        }
    }
</script>

<style lang="less" scoped>
    .van-cell .van-cell__title,
    .van-cell .van-field__label {
        flex: 1;
    }
</style>
